import { FormattedMessage } from "react-intl";
import { Outlet } from "react-router";

import PageTitle from "nvent-web/App/components/PageTitle";
import style from "./SelectionGuideLayout.module.scss";

export const SelectionGuideLayout = () => (
  <div className={style.container}>
    <PageTitle>
      <FormattedMessage id="selectionGuide.title" />
    </PageTitle>

    <Outlet />
  </div>
);
